// extracted by mini-css-extract-plugin
export default {"app_loading":"loading_app_loading__OcRHY","app_loading_icon":"loading_app_loading_icon__TTil-","app_loading_tip":"loading_app_loading_tip__RDFZO"};